// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    off: {
        id: 'schedule.color-light.off',
        defaultMessage: 'Off',
        description: 'Schedule Color Light `Off` label, it has to be short so use abreaviations if too long'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/color-light/intl.js